"use client";

import React from "react";

import Image from "next/image";
import { useTranslations } from "next-intl";

import fileShield2 from "@/assets/images/icons/file-shield-02.svg";
import checkVerified2 from "@/assets/images/icons/check-verified-02.svg";
import shieldTick from "@/assets/images/icons/shield-tick.svg";
import fingerprint3 from "@/assets/images/icons/fingerprint-03.svg";
import type { StaticImageData } from "next/image";

const DATA_SECURITY_ITEMS: {
    key: "item1" | "item2" | "item3";
    icon: StaticImageData;
    alt: string;
}[] = [
    { key: "item1", icon: checkVerified2, alt: "checkVerified2 icon" },
    { key: "item2", icon: shieldTick, alt: "shieldTick icon" },
    { key: "item3", icon: fingerprint3, alt: "fingerprint3 icon" },
];

interface InfoItemProps {
    icon: React.ReactNode;
    text: string;
}

const InfoItem: React.FC<InfoItemProps> = ({ icon, text }) => {
    return (
        <div className="flex items-start mb-6">
            <div className="shrink-0 mr-4">{icon}</div>
            <p className="text-blue-950 text-sm">{text}</p>
        </div>
    );
};

export default function DataSecurityBox() {
    const t = useTranslations("DataSecurity");

    return (
        <div className="bg-white rounded-2xl w-full max-w-lg p-6">
            {/* Header */}
            <div className="flex flex-col items-center mb-8">
                <div className="text-blue-600 mb-4">
                    <Image src={fileShield2} alt="info box header icon" />
                </div>
                <h2 className="text-blue-950 text-2xl font-bold text-center">
                    {t("title")}
                </h2>
            </div>

            {DATA_SECURITY_ITEMS.map(({ key, icon, alt }) => (
                <InfoItem
                    key={key}
                    icon={
                        <div className="w-6 h-6 rounded-full flex items-center justify-center">
                            <Image src={icon} alt={alt} />
                        </div>
                    }
                    text={t(key)}
                />
            ))}
        </div>
    );
}
